'use strict';
var EnhancingPatientComplianceController = /** @class */ (function () {
    /*@ngInject*/
    function EnhancingPatientComplianceController($scope, EducationSubNavService) {
        this.headerContent = "We know that well-honed patient communication skills form the heart of the healing process, yet lack of effective communication is often cited as the number one patient complaint. Successful patient communication is key to achieving treatment compliance and creating the life-changing clinical results that sustain your practice. So, what exactly is effective patient communication, and how do you use it to build your practice? Get valuable advice and resources here.";
        this.education_Partner = [{
                "id": "education_Kalish",
                "img": "170302-EducationalPartners-Kalish-358-214.png",
                "state_id": "patnerKalish",
                "title": "Daniel Kalish, DC",
                "content": " Daniel Kalish, DC believes that physical health is our platform for emotional and spiritual growth - and that we each have the ability to fully heal ourselves."
            },
            {
                "id": "education_Tap",
                "img": "170302-EducationalPartners-TAP-358-214.png",
                "state_id": "",
                "title": "TAP Integrative",
                "content": "TAP Integrative is dedicated to bringing your key business education and clinical resources that help you build your dream practice."
            }];
        $scope.$ctrl.value.selectedpageindex = 4;
        $scope.$ctrl.value.level = '2';
        this.eduSubNavService = EducationSubNavService;
        this.eduSubNavService.level = '2';
    }
    return EnhancingPatientComplianceController;
}());
export default EnhancingPatientComplianceController;
//# sourceMappingURL=enhancing-patient-compliance.controller.js.map